import { jsx } from 'react/jsx-runtime';

const MorningConsultMLogo = (props) => (jsx("svg", { width: "18", height: "20", viewBox: "0 0 18 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0 1V7.7717L8.97106 16.7428L17.9421 7.7717V1L8.97106 9.97106L0 1ZM18.0002 19.0006V12.2289L11.2285 19.0006H18.0002ZM0 19.0006H6.7717L0 12.2289V19.0006Z", fill: "#1D1E30" }) }));

export { MorningConsultMLogo };
